import React from 'react';
import PropTypes from 'prop-types';

const SvgImg = ({ viewbox, title, width, height, children, extraClass, ...others }) => (
  <svg
    viewBox={viewbox}
    width={width}
    height={height}
    className={extraClass}
    {...others}
  >
    <g>
      <title id="title">{title}</title>
    </g>
    {children}
  </svg>
);

const elementOrArrayOfElementPropType = PropTypes.oneOfType([
  PropTypes.arrayOf(PropTypes.element),
  PropTypes.element,
]);

SvgImg.propTypes = {
  viewbox: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(elementOrArrayOfElementPropType),
    elementOrArrayOfElementPropType,
  ]),
  extraClass: PropTypes.string,
};

SvgImg.defaultProps = {
  children: [],
  width: undefined,
  height: undefined,
  extraClass: '',
};

export default React.memo(SvgImg);
